import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import MuiTabs, { TabsTypeMap } from '@material-ui/core/Tabs';
import Tab, { TabTypeMap } from '@material-ui/core/Tab';
import NavigateNextRoundedIcon from '@material-ui/icons/NavigateNextRounded';
import cc from 'classnames';

import styles from './Tabs.module.css';

const generateId = (key: number | string) => `simple-tab-${key}`;

type TabsProps = Omit<TabsTypeMap['props'], 'value'> & {
  options: TabTypeMap['props'][],
  value: number | false,
  className?: string,
  theme?: 'primary' | 'secondary',
  disableVertical?: boolean,
  disabled?: boolean,
};

const Tabs = ({
  options,
  className,
  value,
  textColor = 'primary',
  indicatorColor = 'primary',
  theme = 'primary',
  disableVertical,
  disabled,
  ...rest
}: TabsProps) => {
  const downToSm = useMediaQuery(useTheme().breakpoints.down('sm'));
  const hide = !disableVertical && ((downToSm && value !== false) || (!downToSm && value === false));
  const verticalView = downToSm && !disableVertical;

  return (
    <MuiTabs
      className={cc(styles.tabs, styles[theme], className, { [styles.hide]: hide })}
      textColor={textColor}
      value={value}
      indicatorColor={indicatorColor}
      TabIndicatorProps={{
        hidden: theme === 'secondary',
      }}
      orientation={verticalView ? 'vertical' : 'horizontal'}
      variant={verticalView ? 'fullWidth' : 'scrollable'}
      scrollButtons="off"
      {...rest}
    >
      {options.map((props, index) => (
        <Tab
          key={generateId(index)}
          id={generateId(index)}
          className={cc(styles.tabItem, styles[theme])}
          icon={verticalView ? <NavigateNextRoundedIcon /> : undefined}
          disabled={disabled}
          {...props}
        />
      ))}
    </MuiTabs>
  );
};

export default Tabs;
